import { useCreateGroup } from "src/hooks/store";
import GroupCreateInfo from "./Info";
import GroupCreateParticipants from "./Participants";
function GroupCreate(): JSX.Element | null {
  const createGroup = useCreateGroup();
  if (!createGroup.active) return null;
  if (createGroup.step === 'participants') return <GroupCreateParticipants />;else if (createGroup.step === 'info') return <GroupCreateInfo />;else return null;
}
export default GroupCreate;